var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGrey64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21L14.5714 15.2803M17.2857 9.18182C17.2857 13.7005 13.64 17.3636 9.14286 17.3636C4.64568 17.3636 1 13.7005 1 9.18182C1 4.66312 4.64568 1 9.14286 1C13.64 1 17.2857 4.66312 17.2857 9.18182Z",
    stroke: "#5E636E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey64);
export default __webpack_public_path__ + "static/media/search-grey-64.a73e1ab3.svg";
export { ForwardRef as ReactComponent };